import React from 'react';
import { Row, Col, Card, OverlayTrigger, Tooltip } from 'react-bootstrap';
// External libraries
import moment from 'moment';
// utils
import formatMoney from 'utils/formatMoney';
import { initialsUpperCase } from 'utils/textFormat';

const StatementCard = ({ data }) => {
  // console.log('statement data:', data);
  const splitAuthor = (string) => {
    const index = string.indexOf('-'); // Encuentra el índice del primer guion
    if (index === -1) {
      return string; // Si no hay guion, retorna una string vacía
    }
    return initialsUpperCase(string.substring(index + 1)); // Retorna la parte de la cadena desde el guion hasta el final
  };
  return (
    <Card className="mb-2 px-0">
      <Card.Body className="py-3 px-4 py-lg-0 sh-auto sh-lg-8 card bg-light" style={{ boxShadow: '0 4px 6px rgba(var(--separator-rgb), 0.5)' }}>
        <Row className="g-0 h-100 align-content-center cursor-default">
          <Col xs="12" sm="9" lg="2" className="bg-warningx d-flex flex-column justify-content-center mb-2 mb-lg-0 order-1 order-lg-1 h-lg-100">
            <div className="text-muted text-small d-lg-none ">Concepto</div>
            <OverlayTrigger delay={{ show: 1000, hide: 0 }} placement="top" overlay={<Tooltip id="tooltip-top">{data.statement_text.toUpperCase()}</Tooltip>}>
              <div className="p-0 me-2 bg-secondaryx text-primary text-truncate cursor-pointer">{data.statement_text.toUpperCase()}</div>
            </OverlayTrigger>
          </Col>
          <Col xs="12" sm="6" lg="1" className="bg-infox d-flex flex-column justify-content-center align-items-lg-center mb-2 mb-lg-0 order-3 order-lg-2">
            <div className="text-muted text-small d-lg-none">Fecha Movimiento</div>
            {/* ${statement.creation_date.slice(11, 19)} */}
            <div className="text-alternate">{`${moment(data.created_date).format('DD/MM/YY')}`}</div>
          </Col>
          <Col xs="6" lg="2" className="bg-warningx d-flex flex-column justify-content-center mb-2 mb-lg-0 ps-lg-3 order-4 order-lg-3">
            <div className="text-muted text-small d-lg-none">Referencia</div>
            <OverlayTrigger delay={{ show: 1000, hide: 0 }} placement="top" overlay={<Tooltip id="tooltip-top">{data.reference}</Tooltip>}>
              <div className="text-alternate text-truncate cursor-pointer bg-infox">{data.reference}</div>
            </OverlayTrigger>
          </Col>
          <Col xs="6" lg="2" className="bg-separatex d-flex flex-column justify-content-center mb-2 mb-lg-0 order-4 order-lg-3 ps-4">
            <div className="text-muted text-small d-lg-none">Referencia Adicional</div>
            <OverlayTrigger delay={{ show: 1000, hide: 0 }} placement="top" overlay={<Tooltip id="tooltip-top">{data.reference_trace}</Tooltip>}>
              <div className="text-alternate text-truncate cursor-pointer">{data.statement_text === 'Retorno Guia' && <span>{data.reference_trace}</span>}</div>
            </OverlayTrigger>
          </Col>
          <Col xs="6" lg="2" className="bg-secondaryx d-flex flex-column justify-content-lg-center align-items-center mb-2 mb-lg-0 order-4 order-lg-3">
            <div className="text-muted text-small d-lg-none">Autor</div>
            <div className="text-alternate">{splitAuthor(data.author)}</div>
          </Col>
          <Col
            xs="12"
            sm="12"
            lg="2"
            className="bg-infox d-flex flex-column justify-content-center align-items-end align-items-lg-center mb-2 mb-lg-0 order-last order-lg-5"
          >
            <div className="text-muted text-small d-lg-none">Monto</div>
            <span
              className={`text-alternative ${
                data.statement_code === 'CDS' || data.statement_code === 'RGNU' || data.statement_code === 'DCI' || data.statement_code === 'RAL'
                  ? 'text-success'
                  : 'text-primary'
              }`}
            >
              <span className="text-small text-muted">$</span>
              {formatMoney(data.amount)}
            </span>
          </Col>
          <Col
            xs="12"
            sm="3"
            lg="1"
            className="bg-warningx d-flex flex-column justify-content-center align-items-lg-end mb-2 mb-lg-0 order-2 text-end order-lg-last"
          >
            <div className="text-muted text-small d-lg-none">SALDO</div>
            <span className="text-alternative text-alternate">
              <span className="text-small text-muted ">$</span>
              {formatMoney(data.current_balance)}
            </span>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default StatementCard;
